// English texts of the kit's own components: used as they are when the app binds no catalogue (bindConsole), and the
// keys an app catalogue that binds the console must cover.
export const consoleEn = {
  'chart.avg': 'Avg',
  'chart.batch': 'batch of {n}',
  'chart.legend': 'Legend',
  'chart.limit': 'Limit',
  'chart.noData': 'No data in this range.',
  'chart.noSamples': 'No samples in this range.',
  'chart.select':
    'Drag across the chart to zoom into a span; with the keyboard Shift + arrow keys mark it, Enter zooms.',
  'chart.selected': 'Selected {from} – {to}: release (or Enter) to zoom',
  'chart.notSet': 'not set',
  'chart.now': 'Now',
  'chart.overTime': '{title} over time: now {now}, peak {peak}',
  'chart.peak': 'Peak',
  'chart.request': 'Request',
  'chart.total': '{title}: total {total}',
  'chart.unknown': 'unknown',
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.save': 'Save',
  'common.dismiss': 'Dismiss',
  'common.removeValue': 'remove {value}',
  'common.about': 'About {label}',
  'common.loadMore': 'Load more',
  'common.ofTotal': '{value} of {max}',
  'common.tryAgain': 'Try again',
  'copy.copied': 'Copied',
  'copy.copy': 'Copy',
  'copy.once': 'Copy it now — it is not stored and cannot be shown again.',
  'copy.stored': 'I have stored it',
  'dialog.cancel': 'Cancel',
  'dialog.close': 'Close',
  'dialog.conflict': 'Someone else changed this in the meantime',
  'dialog.conflictDetail': 'Reload to see the current version, then make your change again.',
  'dialog.reload': 'Reload',
  'dialog.save': 'Save',
  'editor.id': 'Id',
  'editor.idHint': 'cannot be changed',
  'editor.idHintNew': 'lowercase slug, e.g. {example}; cannot be changed later',
  'editor.idInvalid': 'lowercase letters, digits and dashes',
  'developer.cancel': 'Cancel',
  'developer.clients.add': 'New API client',
  'developer.clients.create': 'Create',
  'developer.clients.empty': 'No API clients yet',
  'developer.clients.emptyHint': 'An API client lets your system call the API with OAuth client credentials.',
  'developer.clients.lastUsed': 'Last used',
  'developer.clients.limits': 'Limited to',
  'developer.clients.limitsValue': 'Warehouses {warehouses} · owners {owners}',
  'developer.clients.name': 'Name',
  'developer.clients.never': 'Never',
  'developer.clients.new': 'New API client',
  'developer.clients.pickScopes': 'What it may do',
  'developer.clients.revoke': 'Revoke',
  'developer.clients.revokeConfirm': 'Revoke {name}? Its tokens stop working and it cannot be enabled again.',
  'developer.clients.revoked': '{name} revoked',
  'developer.clients.rotate': 'Rotate secret',
  'developer.clients.rotateConfirm': 'Rotate the secret of {name}? The old secret stops working at once.',
  'developer.clients.scopes': 'Scopes',
  'developer.clients.scopesHint': 'A client gets no more than you hold, and only your warehouses and owners.',
  'developer.clients.state': 'State',
  'developer.clients.title': 'API clients',
  'developer.copied': 'Copied',
  'developer.copy': 'Copy',
  'developer.reference.allDomains': 'All domains',
  'developer.reference.body': 'Request body',
  'developer.reference.domain': 'Domain',
  'developer.reference.download': 'Download contract',
  'developer.reference.in': 'In',
  'developer.reference.narrow': '{n} operations match: narrow the search to see them all.',
  'developer.reference.none': 'No operation matches',
  'developer.reference.parameter': 'Parameter',
  'developer.reference.responses': 'Responses',
  'developer.reference.scopes': 'Any of the scopes:',
  'developer.reference.search': 'Find path or operation',
  'developer.reference.title': 'API reference',
  'developer.reference.type': 'Type',
  'developer.reference.version': 'Version {version} · {n} operations',
  'developer.secret.clientId': 'Client id',
  'developer.secret.done': 'I have stored it',
  'developer.secret.once': 'Copy the secret now: it is shown only once. Rotate it to get a new one.',
  'developer.secret.secret': 'Client secret',
  'developer.secret.title': 'Credentials of {name}',
  'developer.secret.tokenUrl': 'Token URL',
  'error.generic': 'Something went wrong',
  'error.noConnection': 'No connection',
  'error.unreachable': 'The server could not be reached.',
  'field.colour': 'A colour as #rrggbb',
  'field.from': 'From',
  'field.max': 'At most {max}',
  'field.min': 'At least {min}',
  'field.notNumber': 'Not a number',
  'field.required': 'Required',
  'field.to': 'To',
  'field.toBeforeFrom': 'Before the start date',
  'field.wholeNumber': 'A whole number',
  'grid.label': 'Results',
  'grid.clear': 'Clear',
  'grid.clearSelection': 'Clear selection',
  'grid.columns': 'Columns',
  'grid.copyLink': 'Copy link to this view',
  'grid.deleteView': 'Delete view',
  'grid.empty': 'Nothing matches.',
  'grid.export': 'Export',
  'grid.exportCsv': 'CSV (all matching rows)',
  'grid.exportXlsx': 'Excel (all matching rows)',
  'grid.loading': 'Loading…',
  'grid.noMatches': 'No matches',
  'grid.noViews': 'No saved views yet.',
  'grid.rows': '{count} rows',
  'grid.saveView': 'Save current view…',
  'grid.search': 'Search',
  'grid.selectAllMatching': 'Select all {count} matching',
  'grid.selectLoaded': 'Select the loaded rows',
  'grid.selected': '{count} selected',
  'grid.shareView': 'Save and share…',
  'grid.sharedView': 'shared',
  'grid.viewName': 'Name of the view',
  'grid.views': 'Views',
  'pager.next': 'Next',
  'pager.none': 'No rows',
  'pager.previous': 'Previous',
  'pager.range': '{from}–{to} of {total}',
  'shell.collapse': 'Collapse {label}',
  'shell.expand': 'Expand {label}',
  'shell.closeMenu': 'Close menu',
  'shell.navigation': 'Navigation',
  'shell.openMenu': 'Open menu',
  'shell.theme.dark': 'dark',
  'shell.theme.light': 'light',
  'shell.theme.system': 'system',
  'shell.themeLabel': 'Theme: {current} (switch to {next})',
  'time.hAgo': '{n} h ago',
  'time.justNow': 'just now',
  'time.minAgo': '{n} min ago',
  'dirty.discard': 'Discard changes',
  'dirty.message': 'Your changes are not saved yet.',
  'dirty.title': 'Discard your changes?',
  'files.dropMany': 'Drop files here or browse',
  'files.dropOne': 'Drop a file here or browse',
  'files.max': 'at most {max}',
  'files.tooBig': '{name} is larger than {max}',
  'files.types': '{accept}',
  'files.wrongType': '{name} is not an accepted file type',
  'palette.hint': 'Type at least {n} characters.',
  'palette.none': 'Nothing found for “{q}”.',
  'palette.open': 'Search',
  'palette.placeholder': 'Search…',
  'palette.searching': 'Searching…',
  'palette.title': 'Search',
  'sort.ascending': '{label}, ascending',
  'sort.by': 'Sort by',
  'sort.default': 'Default order',
  'sort.descending': '{label}, descending',
  'shell.language': 'Language',
} satisfies Record<string, string>;

/** A key of the kit's own texts (`consoleEn`); an app catalogue spreading `consoleEn` keeps these keys typed. */
export type ConsoleTextKey = keyof typeof consoleEn;
